import React from 'react';
import logoGlpi from './../../../public/Images/glpi.png';
import logoAeflor  from './../../../public/Images/AEFLORcor.png'
import logoArbor  from './../../../public/Images/Imgarbor.png'

function Features(){
    return <section id="features">
        <div className="">
            <div className="row">
                <div className="col-lg-4 col-md-4 feature-box">
                <a className="nav-link" aria-current="page" href="/parceria/login">
                    <i className="icon fa fa-users fa-5x"></i></a>
                    <h3>Parceiros</h3>
                    <p>Acessar o Parceiros de descontos <b>Floresta Supermarket</b></p>
                </div>   

               
                {/*<div className="col-lg-3 col-md-3 feature-box">
                    <a className="nav-link" aria-current="page" href="/arbor/aeflor">
                    <img src={logoAeflor}className="iconglpi" /></a>
                    <h3> Associação</h3>
                    <p>Dados da AEFLOR e inscrição para a confraternização 2024.</p>
                </div> 
                */}

                <div className="col-lg-4 col-md-4 feature-box">
                    <a className="nav-link" aria-current="page" href="/arbor/login">
                    <img src={logoArbor} className="iconglpi" /></a>
                    <h3 className='txt-maiusculo'>Arbor</h3>
                    <p>Acessar o sistema ARBOR WEB</p>
                </div>

                <div className="col-lg-4 col-md-4 feature-box">
                    <a className="nav-link" aria-current="page" href="/restaurante/login">
                    <i className="icon fa fa-cutlery fa-5x"></i></a>
                    <h3>Restaurantes</h3>
                    <p>Parceiros restaurantes</p>
                </div>         



               {/* <div className="col-lg-3 col-md-3 feature-box">
                <a className="nav-link" aria-current="page" href="https://glpi.florestasm.com.br">
                    <img src={logoGlpi} className="iconglpi" /></a>
                    <h3>Chamados</h3>
                    <p>Através da ferramenta GLPI, todos os usuários podem abrir seus chamados para os departamentos de tecnologia e manutenção</p>
                </div>                    
                */}
                       
            </div>
        </div>
    </section>;
  }

export default Features;